"use strict";
var FromEventObservable_1 = require('./FromEventObservable');
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/observable/fromEvent.js